import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class SsoBranchProvider {

    private _service: string = 'payroll';
    private _model: string = 'Ssobranchservices';

    constructor(
        private nestApiProvider: NestApiProvider,
    ) {
    }

    public getSsoBranch(): Observable<any> {
        const _method: string = 'GET';
        const _func: string = 'getSsoBranch';
        const _params: any = {};
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _func, _params, _body)
    }

    public addSsoBranch(payload: AddUpdateSso): Observable<any> {
        const _method: string = 'POST';
        const _func: string = 'addSsoBranch';
        const _params: any = payload;
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body)
    }

    public updateSsoBranch(payload: AddUpdateSso): Observable<any> {
        const _method: string = 'POST';
        const _func: string = 'updateSsoBranch';
        const _params: any = payload;
        const _urlParams: any = {};
        const _body: any = {};

        const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
        return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body)
    }
}

export interface AddUpdateSso {
    ssoBranchCode: string;
    ssobranchName: string;
    ssoAddress: string;
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/sso-branch/sso-branch.ts